module.exports = __webpack_public_path__ + "img/qbert_questions_p18.e774dd82.jpg";